import React from 'react'
import {Grid} from '@material-ui/core'
import {useDispatch, useSelector} from 'react-redux'
import {actions as authActions} from '../../redux/modules/auth'
import {RootState} from '../../redux/rootReducer'
import {RootGrid, Title, LogoutButton, ActivityIndicator, Instructions} from './styled'
import {Alert} from '@material-ui/lab'

const LogoutPage: React.FC = () => {
  const {dataState} = useSelector((state: RootState) => state.auth)
  const dispatch = useDispatch()

  const onLogoutClick = () => {
    dispatch(authActions.logout())
  }

  return (
    <RootGrid container spacing={3}>
      <Grid item xs={12}>
        <Title>Logout</Title>
      </Grid>
      <Grid item xs={12}>
        <Instructions>This will completely log you out of the admin site.</Instructions>
      </Grid>
      <Grid container item xs={12} justify="center">
        {dataState.state === 'loading' ? (
          <ActivityIndicator />
        ) : (
          <LogoutButton onClick={onLogoutClick}>Logout</LogoutButton>
        )}
      </Grid>
      <Grid container item xs={12} justify="center">
        {dataState.error && <Alert severity="error">{dataState.error.message}</Alert>}
      </Grid>
    </RootGrid>
  )
}

export default LogoutPage
